export const richTextListTypes = ['ol', 'ul'];
